import React from 'react';

export const BlueTick = ({ color }) => {
  return (
    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.84375 5.25202L5.94821 9.20961L14.1562 1.29443"
        stroke={color || '#3D88E0'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
